import React from 'react';
import CardSectionTitle from './CardSectionTitle';
import './detailCard.scss';
import GeneralInfo from './GeneralInfo';
import Rates, { getRatesSubtittle } from './Rates';
import Restrictions from './Restrictions';
import useTranslate from '../../../../customHooks/useTranslate';

const DetailCard = ({ item, qualityStatus }) => {
    const generalInfo = {
        date: item.date,
        lastUpdated: item.lastUpdated,
        los: item.los,
        availability: item.availability,
        qualityStatus,
    };

    const translate = useTranslate();

    const getTranslatedRatesSubtittle = (rates, currency) => {
        const subtittle = getRatesSubtittle(rates);
        const currencySubtittle =
            subtittle === 'no_rates' ? '' : ` - ${currency}`;
        return `${translate(subtittle)}${currencySubtittle}`;
    };

    const rateSubtittle = getTranslatedRatesSubtittle(
        item.rates,
        item.currency
    );

    return (
        <div className='detail-card'>
            <div className='section'>
                <GeneralInfo {...generalInfo} />
            </div>
            <div className='section'>
                <CardSectionTitle title='rates' subTitle={rateSubtittle} />
                <Rates
                    rates={item?.rates}
                    baseOccupancy={item?.baseOccupancy}
                />
            </div>
            <div className='section'>
                <CardSectionTitle title='restrictions' />
                <Restrictions restrictions={item.restrictions} />
            </div>
        </div>
    );
};

export default DetailCard;
